module.exports = __webpack_public_path__ + "img/telegram.dd496809.svg";